import { combineReducers } from '@reduxjs/toolkit';

import ShakhsSalesBimehNamehDetailSlice from 'Feature/Khodro/ShakhsSales/SakhsSalesBimehNameh/Pages/Detail/reducers/ShakhsSalesBimehNamehDetailSlice';
import shakhSalesBimehNamehPrintSlice from 'Feature/Khodro/ShakhsSales/SakhsSalesBimehNameh/Pages/Print/reducers/shakhSalesBimehNamehPrintSlice';

import elhaghiyehHayeSaderehSlice from '../SakhsSalesBimehNameh/Pages/ElhaghiyehHayeSadereh/reducers/elhaghiyehHayeSaderehSlice';
import shakhsSalesBimehNamehEstelamAndSodoorSlice from '../SakhsSalesBimehNameh/Pages/EstelamAndSodoor/reducers/shakhsSalesBimehNamehEstelamAndSodoorSlice';
import sodoorBimehNamehByPelakSlice from '../SakhsSalesBimehNameh/Pages/SodoorBimehNamehByPelak/reducers/sodoorBimehNamehByPelakSlice';
import sodoorBimehNamehByTavizPelakSlice from '../SakhsSalesBimehNameh/Pages/SodoorBimehNamehByTavizPelak/reducers/sodoorBimehNamehByTavizPelakSlice';

export const khodroShakhsSalesReducers = combineReducers({
  bimehNamehPrint: shakhSalesBimehNamehPrintSlice,
  bimehNamehSodoorByPelak: sodoorBimehNamehByPelakSlice,
  bimehNamehDetail: ShakhsSalesBimehNamehDetailSlice,
  bimehNamehEstelamAndSodoor: shakhsSalesBimehNamehEstelamAndSodoorSlice,
  bimehNamehSodoorByTavizPelak: sodoorBimehNamehByTavizPelakSlice,
  elhaghiyehHayeSadereh: elhaghiyehHayeSaderehSlice,
});
